import script from "./AddSdkProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSdkProduct.vue?vue&type=script&setup=true&lang=js"

import "./AddSdkProduct.vue?vue&type=style&index=0&id=c77a58a6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c77a58a6"]])

export default __exports__